export default __webpack_public_path__ + "static/media/DurationImage.98c46bf8.png";